/**
 * @generated SignedSource<<b56832b212bde518705878a527ab11ab>>
 * @relayHash 3913fb74e024e1e47fcde7cf49b0e5a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45bb7e371950d1b4df3eb6fac3082cefa4f0a3e30838d203ca5fdca51cb25b86

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedOriginalEstimateQuery } from './decomposedOriginalEstimateQuery.graphql';

const node: PreloadableConcreteRequest<decomposedOriginalEstimateQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "45bb7e371950d1b4df3eb6fac3082cefa4f0a3e30838d203ca5fdca51cb25b86",
    "metadata": {},
    "name": "decomposedOriginalEstimateQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
